import { parseTextSegments } from "@/lib/text-segments"
import type { MentionHandleGroup } from "@/types"

export function applyMentionFallbacks(
  body: string,
  mentionHandleGroups: MentionHandleGroup[],
): string {
  const groupsByLabel = Object.fromEntries(
    mentionHandleGroups.map((group) => [group.label, group]),
  )

  return parseTextSegments(body)
    .map((segment) => {
      if (segment.type !== "mention") {
        return segment.value
      }
      const fallback = groupsByLabel[segment.value.slice(1)]?.fallback_text
      return fallback && fallback.length > 0 ? fallback : segment.value
    })
    .join("")
}
